/* Beyond Tanned — PDP behaviour
   Buy box (gallery, size/tier/plan selection, live pricing, add to cart),
   accordions, and the sticky add-to-cart bar. No dependencies. */
(function () {
  'use strict';

  /* ---------------- money ----------------
     `format` is either a full pattern containing the amount placeholder, or a
     bare prefix such as "£". Both are supported because a placeholder written
     into a Liquid string literal gets stripped before it reaches the page. */
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/.exec(format || '');
    var name = placeholder ? placeholder[1] : 'amount';
    var out;
    if (name === 'amount_no_decimals') {
      out = whole;
    } else if (name === 'amount_with_comma_separator') {
      out = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    } else if (name === 'amount_no_decimals_with_comma_separator') {
      out = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    } else {
      out = whole + '.' + parts[1];
    }
    return placeholder ? format.replace(placeholder[0], out) : (format || '£') + out;
  }

  /* Wholesale prices are ex VAT — checkout charges the VAT-inclusive
     equivalent — so they render with an "ex VAT" tag and an inc-VAT
     companion price. */
  var VAT_TAG = ' <span style="font-size:.62em;font-weight:600;letter-spacing:.02em">ex VAT</span>';

  function incVat(cents, rate) {
    return Math.round(cents * (1 + rate));
  }

  /* Tier maths must mirror the "Bundle" automatic discounts in Shopify admin:
     Shopify takes the percentage off each unit, truncated to the penny, then
     multiplies by quantity. Rounding any other way quotes totals a penny or
     two off what the cart actually charges. */
  function tierUnitPrice(unit, off) {
    return unit - Math.floor(unit * off / 100);
  }

  /* ---------------- accordions ---------------- */
  function initAccordions(root) {
    root.querySelectorAll('.bt-acc__btn').forEach(function (btn) {
      if (btn.dataset.btBound) return;
      btn.dataset.btBound = '1';
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        var open = btn.getAttribute('aria-expanded') === 'true';
        var group = btn.closest('[data-bt-accordion-group]');
        if (group && group.dataset.btAccordionGroup === 'single' && !open) {
          group.querySelectorAll('.bt-acc__btn[aria-expanded="true"]').forEach(function (other) {
            other.setAttribute('aria-expanded', 'false');
            var op = document.getElementById(other.getAttribute('aria-controls'));
            if (op) op.hidden = true;
          });
        }
        btn.setAttribute('aria-expanded', String(!open));
        if (panel) panel.hidden = open;
      });
    });
  }

  /* ---------------- gallery ---------------- */
  function initGallery(box) {
    var gallery = box.querySelector('[data-bt-gallery]');
    if (!gallery) return;
    var slides = gallery.querySelectorAll('[data-bt-slide]');
    var thumbs = gallery.querySelectorAll('[data-bt-thumb]');
    var counter = gallery.querySelector('[data-bt-counter]');
    if (!slides.length) return;
    var index = 0;

    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      thumbs.forEach(function (t, i) { t.setAttribute('aria-current', String(i === index)); });
      if (counter) counter.textContent = (index + 1) + ' / ' + slides.length;
    }

    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    var prev = gallery.querySelector('[data-bt-prev]');
    var next = gallery.querySelector('[data-bt-next]');
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
    show(0);
  }

  /* ---------------- buy box ---------------- */
  function initBuyBox(box) {
    var configEl = box.querySelector('[data-bt-config]');
    if (!configEl) return;
    var cfg;
    try { cfg = JSON.parse(configEl.textContent); } catch (e) { return; }
    cfg.vatRate = Number(cfg.vatRate) || 0;

    var form = box.querySelector('[data-bt-form]');
    var qtyInput = box.querySelector('[data-bt-qty]');
    var planInput = box.querySelector('[data-bt-selling-plan]');
    var tiers = Array.prototype.slice.call(box.querySelectorAll('[data-bt-tier]'));
    var tiersField = box.querySelector('[data-bt-tiers-field]');
    var plans = Array.prototype.slice.call(box.querySelectorAll('[data-bt-plan]'));
    var planSelect = box.querySelector('[data-bt-plan-select]');

    var elTotal = box.querySelector('[data-bt-total]');
    var elVatInc = box.querySelector('[data-bt-vat-inc]');
    var elCompare = box.querySelector('[data-bt-compare]');
    var elWas = box.querySelector('[data-bt-was]');
    var elSaving = box.querySelector('[data-bt-saving]');
    var elPerUnit = box.querySelector('[data-bt-per-unit]');
    var elPerSession = box.querySelector('[data-bt-per-session]');
    var elCta = box.querySelector('[data-bt-cta-label]');
    var submitBtn = box.querySelector('[data-bt-submit]');

    var state = {
      qty: 1,
      tierOff: 0,
      subscribed: cfg.defaultPlan === 'subscribe' && cfg.sellingPlans.length > 0,
      planId: cfg.sellingPlans.length ? cfg.sellingPlans[0].id : null
    };

    var activeTier = tiers.filter(function (t) { return t.getAttribute('aria-checked') === 'true'; })[0] || tiers[0];
    if (activeTier) {
      state.qty = parseInt(activeTier.dataset.qty, 10) || 1;
      state.tierOff = parseFloat(activeTier.dataset.discount) || 0;
    }
    if (planSelect && planSelect.value) state.planId = planSelect.value;

    /* Subscriptions are single-unit only (when the section says so): the
       multi-buy tiers apply to one-time purchases, so the tier picked for
       one-time is remembered and restored when switching back. */
    state.onetimeQty = state.qty;
    state.onetimeTierOff = state.tierOff;
    if (cfg.subscribeSingleUnit && state.subscribed) {
      state.qty = 1;
      state.tierOff = 0;
    }

    // Unit price for the currently selected plan. Subscription prices come
    // straight from Shopify's selling plan allocation, so they always match
    // what the customer is actually charged at checkout.
    function unitPrice() {
      if (state.subscribed && state.planId) {
        var match = cfg.sellingPlans.filter(function (p) { return String(p.id) === String(state.planId); })[0];
        if (match) return match.price;
      }
      return cfg.price;
    }

    function render() {
      var gross = cfg.price * state.qty;
      var net = tierUnitPrice(unitPrice(), state.tierOff) * state.qty;
      var each = state.qty ? net / state.qty : net;

      if (elTotal) {
        if (cfg.vatRate > 0) {
          elTotal.innerHTML = formatMoney(net, cfg.moneyFormat) + VAT_TAG;
        } else {
          elTotal.textContent = formatMoney(net, cfg.moneyFormat);
        }
      }
      if (elVatInc && cfg.vatRate > 0) {
        elVatInc.textContent = formatMoney(incVat(net, cfg.vatRate), cfg.moneyFormat) + ' inc VAT';
      }
      if (elCompare) elCompare.hidden = !(net < gross);
      if (elWas) elWas.textContent = formatMoney(gross, cfg.moneyFormat);
      if (elSaving) elSaving.textContent = cfg.savingPrefix + ' ' + formatMoney(gross - net, cfg.moneyFormat);

      if (elPerUnit) {
        elPerUnit.textContent = cfg.unitVolume > 0
          ? formatMoney(Math.round(each / cfg.unitVolume * 100), cfg.moneyFormat) + ' ' + cfg.perVolumeLabel
          : '';
      }
      if (elPerSession) {
        elPerSession.textContent = cfg.sessions > 1
          ? formatMoney(Math.round(each / cfg.sessions), cfg.moneyFormat) + ' ' + cfg.perSessionLabel
          : cfg.singleSessionLabel;
      }

      if (elCta) {
        var ctaText = (state.subscribed ? cfg.ctaSubscribe : cfg.ctaOneTime) + ' — ' + formatMoney(net, cfg.moneyFormat);
        if (cfg.vatRate > 0) {
          elCta.innerHTML = ctaText + VAT_TAG;
        } else {
          elCta.textContent = ctaText;
        }
      }

      if (tiersField) tiersField.hidden = !!(cfg.subscribeSingleUnit && state.subscribed);

      tiers.forEach(function (t) {
        var q = parseInt(t.dataset.qty, 10) || 1;
        var off = parseFloat(t.dataset.discount) || 0;
        var unit = tierUnitPrice(unitPrice(), off);
        var eachEl = t.querySelector('[data-bt-tier-each]');
        if (eachEl) {
          eachEl.textContent = formatMoney(unit, cfg.moneyFormat) + ' ' + cfg.eachLabel + (cfg.vatRate > 0 ? ' ex VAT' : '');
        }
        t.setAttribute('aria-checked', String(q === state.qty));
      });

      plans.forEach(function (p) {
        p.setAttribute('aria-checked', String((p.dataset.btPlan === 'subscribe') === state.subscribed));
      });
      if (planSelect) planSelect.hidden = !state.subscribed;

      if (qtyInput) qtyInput.value = state.qty;
      if (planInput) {
        planInput.value = state.subscribed && state.planId ? state.planId : '';
        planInput.disabled = !state.subscribed || !state.planId;
      }

      document.dispatchEvent(new CustomEvent('bt:pdp:update', {
        detail: {
          total: formatMoney(net, cfg.moneyFormat),
          totalIncVat: cfg.vatRate > 0 ? formatMoney(incVat(net, cfg.vatRate), cfg.moneyFormat) : null,
          subscribed: state.subscribed,
          qty: state.qty,
          sectionId: cfg.sectionId
        }
      }));
    }

    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        state.qty = parseInt(t.dataset.qty, 10) || 1;
        state.tierOff = parseFloat(t.dataset.discount) || 0;
        state.onetimeQty = state.qty;
        state.onetimeTierOff = state.tierOff;
        render();
      });
    });

    plans.forEach(function (p) {
      p.addEventListener('click', function () {
        state.subscribed = p.dataset.btPlan === 'subscribe';
        if (cfg.subscribeSingleUnit) {
          if (state.subscribed) {
            state.qty = 1;
            state.tierOff = 0;
          } else {
            state.qty = state.onetimeQty;
            state.tierOff = state.onetimeTierOff;
          }
        }
        render();
      });
    });

    if (planSelect) {
      planSelect.addEventListener('change', function () { state.planId = planSelect.value; render(); });
      planSelect.addEventListener('click', function (e) { e.stopPropagation(); });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return; // let the plain form post happen
        e.preventDefault();
        if (submitBtn) submitBtn.disabled = true;
        var errEl = box.querySelector('[data-bt-error]');
        if (errEl) errEl.hidden = true;
        var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{
              id: cfg.variantId,
              quantity: state.qty,
              selling_plan: state.subscribed && state.planId ? Number(state.planId) : undefined
            }]
          })
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not add to cart');
            if (cfg.afterAdd === 'cart') {
              window.location.href = root + 'cart';
              return;
            }
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'bt-pdp' } }));
            if (submitBtn) {
              submitBtn.disabled = false;
              var label = submitBtn.querySelector('[data-bt-cta-label]');
              if (label) {
                var original = label.textContent;
                label.textContent = cfg.addedLabel;
                setTimeout(function () { label.textContent = original; }, 2000);
              }
            }
          })
          .catch(function (err) {
            if (submitBtn) submitBtn.disabled = false;
            if (errEl) { errEl.textContent = err.message; errEl.hidden = false; }
          });
      });
    }

    render();
  }

  /* ---------------- sticky bar ---------------- */
  function initSticky(bar) {
    var threshold = parseInt(bar.dataset.btThreshold, 10) || 760;
    var priceEl = bar.querySelector('[data-bt-sticky-price]');
    var subEl = bar.querySelector('[data-bt-sticky-sub]');
    var trigger = bar.querySelector('[data-bt-sticky-add]');

    function onScroll() {
      var y = window.scrollY || document.documentElement.scrollTop;
      bar.classList.toggle('is-visible', y > threshold);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    document.addEventListener('bt:pdp:update', function (e) {
      if (priceEl) {
        if (e.detail.totalIncVat) {
          priceEl.innerHTML = e.detail.total + VAT_TAG;
        } else {
          priceEl.textContent = e.detail.total;
        }
      }
      var vatEl = bar.querySelector('[data-bt-sticky-vat]');
      if (vatEl && e.detail.totalIncVat) {
        vatEl.textContent = e.detail.totalIncVat + ' inc VAT';
      }
      if (subEl && subEl.dataset.btSubscribeText && subEl.dataset.btOnceText) {
        subEl.textContent = e.detail.subscribed ? subEl.dataset.btSubscribeText : subEl.dataset.btOnceText;
      }
    });

    if (trigger) {
      trigger.addEventListener('click', function () {
        var target = document.querySelector('[data-bt-submit]');
        if (target) {
          target.click();
        } else {
          window.location.hash = '#bt-buy';
        }
      });
    }
  }

  /* ---------------- boot ---------------- */
  function boot(scope) {
    var root = scope || document;
    initAccordions(root);

    // Sticky bars bind first so they catch the buy box's initial price event.
    root.querySelectorAll('[data-bt-sticky]').forEach(function (bar) {
      if (bar.dataset.btBound) return;
      bar.dataset.btBound = '1';
      initSticky(bar);
    });

    root.querySelectorAll('[data-bt-buybox]').forEach(function (box) {
      if (box.dataset.btBound) return;
      box.dataset.btBound = '1';
      initGallery(box);
      initBuyBox(box);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  // Re-initialise after a theme-editor section reload.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
